import {Field, reduxForm} from 'redux-form'
import { Link } from 'react-router'
import Captcha from './Captcha'
import validator from 'validator'

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'The email address is required'
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'The value is not a valid email address'
  }
  if (!values.captcha) {
    errors.captcha = 'The captcha is not valid'
  }
  return errors
}

const inputField = (field) => (
  <div>
    <input {...field.input}
      type='text'
      maxLength={field.maxLength}
      className='form-control'
      placeholder='Registered email address' />
    <small className='error'>
      {field.meta.touched ? field.meta.error : ''}
    </small>
  </div>
)

let ForgotPasswordForm = class forgotPasswordForm extends React.Component {
  render () {
    let {handleSubmit} = this.props

    return (
      <form onSubmit={handleSubmit}>
        <p className='visible-md visible-lg'>
          To reset your account password. Enter the email address you registered with and we&#39;ll send you instructions.
        </p>
        <p className='visible-xs visible-sm text-center'>
          To reset your account password. Enter the email address you registered with and we&#39;ll send you instructions.
        </p>
        <br />
        <Field
          component={inputField}
          name='email'
          maxLength='40'
          autoCorrect='off'
          autoCapitalize='off'
          spellCheck='false' />
        <br />
        <Field
          component={Captcha}
          name='captcha'
          />
        <button type='submit' className='btn btn-primary pull-right visible-lg visible-md'>
          Submit
        </button>
        <button type='submit' className='btn btn-primary btn-block visible-xs visible-sm'>
          Submit
        </button>
        <div className='visible-xs visible-sm'>
          <br />
          <p id='sign-in' className='text-center'>
            Don&#39;t have a Moka account?
            <Link to='/register'> Sign Up </Link>
          </p>
        </div>
      </form>
    )
  }
}

ForgotPasswordForm.propTypes = {
  data: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  error: React.PropTypes.object,
  currentlySending: React.PropTypes.bool
}

ForgotPasswordForm = reduxForm({
  form: 'forgotPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
})(ForgotPasswordForm)

export default ForgotPasswordForm



// WEBPACK FOOTER //
// ./app/pages/ForgotPassword/ForgotPasswordForm.js